import ManualInvestigatorSIteId from "../Trials/ManualInvestigatorSIteId";
import MainAccordion from "../Accordion/MainAccordion";

const InvestigatorSiteIdAccordion = ({
  trialDetails,
  setChangeTrialSetting,
  investigatorChanged,
  setInvestigatorChanged,
  setTrialDetails,
  allInvestigators,
  onInvestigatorChange,
  handleBasicInfoUpdate,
  setInfoSettingChanged,
  AllInvestigatorsData,
  setAllInvestigators,
}) => {
  return (
    <MainAccordion
      title="Sites & Investigators"
      data={
        <ManualInvestigatorSIteId
          trialDetails={trialDetails}
          setTrialDetails={setTrialDetails}
          allInvestigators={allInvestigators}
          onInvestigatorChange={onInvestigatorChange}
          handleBasicInfoUpdate={handleBasicInfoUpdate}
          setChangeTrialSetting={setChangeTrialSetting}
          investigatorChanged={investigatorChanged}
          setInvestigatorChanged={setInvestigatorChanged}
          setInfoSettingChanged={setInfoSettingChanged}
          AllInvestigatorsData={AllInvestigatorsData}
          setAllInvestigators={setAllInvestigators}
        />
      }
    />
  );
};
export default InvestigatorSiteIdAccordion;
